import { Injectable, inject, signal } from '@angular/core';
import { Subject } from 'rxjs';
import { Notification } from '../models/notification.model';
import { NotificationService } from './notification.service';
import { NotificationSearchDto } from '../models/notification/notification-search.dto';

export interface BillingStatusChangedEvent {
  facilityId: string;
  type: 'corporate_payer_removed' | 'facility_reinstated';
}

@Injectable({ providedIn: 'root' })
export class NotificationsManagerService {
  markAsRead = new Subject<string>();
  shiftNeedSelected$ = new Subject<Notification>();
  billingStatusChanged$ = new Subject<BillingStatusChangedEvent>();

  /** Emits the updated unread notification count whenever it changes */
  unreadCountChanged$ = new Subject<number>();

  private unreadNotificationCount = signal<number>(0);

  private notificationService = inject(NotificationService);

  /**
   * Fetches the current unread count and emits it via unreadCountChanged$.
   * Call this after marking notifications as read to update all listeners.
   */
  refreshUnreadCount(params?: NotificationSearchDto): void {
    this.notificationService
      .getNotifications({
        ...params,
        isRead: false,
        pageSize: 1,
        pageNumber: 1
      })
      .subscribe({
        next: (response) => {
          this.unreadCountChanged$.next(response.totalCount);
          this.unreadNotificationCount.set(response.totalCount);
        },
        error: () => {
          // Silent fail
        }
      });
  }

  onMarkAsRead(all: boolean): void {
    this.unreadNotificationCount.set(
      all ? 0 : this.unreadNotificationCount() - 1
    );
    this.unreadCountChanged$.next(this.unreadNotificationCount());
  }
}
